const CSRF_COOKIE_NAME = "pericles_csrf";
const CSRF_HEADER_NAME = "x-csrf-token";
const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

let installed = false;

function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
}

function resolveRequestUrl(input: RequestInfo | URL): URL {
  if (typeof input === "string") {
    return new URL(input, window.location.origin);
  }
  if (input instanceof URL) {
    return input;
  }
  return new URL(input.url, window.location.origin);
}

function normalizeMethod(input: RequestInfo | URL, init?: RequestInit): string {
  const requestMethod =
    typeof input !== "string" && !(input instanceof URL) && input instanceof Request ? input.method : undefined;
  return (init?.method ?? requestMethod ?? "GET").toUpperCase();
}

function shouldAttachCsrf(input: RequestInfo | URL, init?: RequestInit): boolean {
  const method = normalizeMethod(input, init);
  if (SAFE_METHODS.has(method)) {
    return false;
  }

  const url = resolveRequestUrl(input);
  return url.origin === window.location.origin;
}

export function installBrowserSecurityFetch(): void {
  if (installed || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    if (!shouldAttachCsrf(input, init)) {
      return originalFetch(input, init);
    }

    let csrfToken = readCookie(CSRF_COOKIE_NAME);
    if (!csrfToken) {
      await originalFetch("/auth/csrf", { method: "GET", headers: { accept: "application/json" } });
      csrfToken = readCookie(CSRF_COOKIE_NAME);
    }

    const headers = new Headers(init?.headers ?? (typeof input !== "string" && !(input instanceof URL) ? input.headers : undefined));
    if (csrfToken && !headers.has(CSRF_HEADER_NAME)) {
      headers.set(CSRF_HEADER_NAME, csrfToken);
    }

    return originalFetch(input, { ...init, headers });
  };
}
